import React, { useState } from "react";
  import Papa from "papaparse";
import JSZip from "jszip";
import { saveAs } from "file-saver";

const WeeklyHiringsummary = () => {
  const [activeTab, setActiveTab] = useState("tab1");





const exportAllTabsAsCSV = () => {
  const zip = new JSZip();

  // 1. Weekly Summary
  const weeklySummary = [
    ["Sr. No", "Position", "Hiring For", "Requisition From", "Closure Responsibility", "Experience Level", "Status", "CVs Shared", "Interviews Conducted", "Shortlisted", "Offers Made", "Joined"],
    ["1", "Magento Developer – Gurgaon", "Client", "Client", "Client", "4+ Years", "Open", "2", "1", "1", "0", "0"],
    ["2", "BDE – Junior", "NN", "NN", "NN", "6 months", "In Progress", "1", "1", "0", "0", "0"],
    ["3", "Python Dev – Freelancer", "NN", "NN", "NN", "7+ Years", "In Progress", "1", "0", "0", "0", "0"],
  ];
  const csv1 = Papa.unparse(weeklySummary);
  zip.file("Weekly_Hiring_Summary.csv", csv1);

  // 2. Candidate Pipeline
  const pipeline = [
    ["Sr. No", "Position", "Name", "Mobile No", "Email", "Total Exp", "Relevant Exp", "Current CTC", "ECTC", "Notice Period", "Location", "Round", "Feedback", "Status"],
    ["1", "Magento Developer – Gurgaon", "Swati Sharma", "9876543210", "swati@email.com", "4.5", "3.8", "₹9 LPA", "₹13 LPA", "Immediate", "Gurgaon", "Tech + HR", "Positive", "Shortlisted"],
    ["2", "Data Modeler – Freelancer", "Rajat Verma", "9876543211", "rajat@email.com", "6.2", "6", "₹15 LPA", "₹18 LPA", "7 days", "Remote", "Screening", "OK", "On Hold"],
  ];
  const csv2 = Papa.unparse(pipeline);
  zip.file("Candidate_Pipeline.csv", csv2);

  // 3. Feedback Summary
  const feedback = [
    ["Sr. No", "Candidate", "Position", "Round", "Interviewer", "Date", "Feedback Summary", "Go Ahead", "Remarks"],
    ["1", "Swati Sharma", "Magento Dev", "Tech", "Amit", "2 Aug", "Good technical hold, confident, relevant exp", "Yes", "Can negotiate on CTC"],
    ["2", "Rajat Verma", "Data Modeler", "Screening", "Shruti", "3 Aug", "Lacking real-time implementation clarity", "No", "Ask to reapply in 6 months"],
  ];
  const csv3 = Papa.unparse(feedback);
  zip.file("Feedback_Summary.csv", csv3);

  // 4. Offer Tracker
  const offers = [
    ["Sr. No", "Name", "Position", "Offered CTC", "Status", "Expected DOJ", "Remarks"],
    ["1", "Swati Sharma", "Magento Dev – Gurgaon", "₹13 LPA", "Offer Accepted", "5 Aug", "Awaiting final doc verification"],
  ];
  const csv4 = Papa.unparse(offers);
  zip.file("Offer_Tracker.csv", csv4);

  // Generate and download ZIP
  zip.generateAsync({ type: "blob" }).then(content => {
    saveAs(content, "Hiring_Report_All_Tabs.zip");
  });
};


  const renderTable = () => {
    switch (activeTab) {
      case "tab1":
        return (
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Position</th>
                <th>Hiring For</th>
                <th>Requisition From</th>
                <th>Closure Responsibility</th>
                <th>Experience Level</th>
                <th>Status</th>
                <th>CVs Shared</th>
                <th>Interviews Conducted</th>
                <th>Shortlisted</th>
                <th>Offers Made</th>
                <th>Joined</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Magento Developer – Gurgaon</td>
                <td>Client</td>
                <td>Client</td>
                <td>Client</td>
                <td>4+ Years</td>
                <td>Open</td>
                <td>2</td>
                <td>1</td>
                <td>1</td>
                <td>0</td>
                <td>0</td>
              </tr>
              <tr>
                <td>2</td>
                <td>BDE – Junior</td>
                <td>NN</td>
                <td>NN</td>
                <td>NN</td>
                <td>6 months</td>
                <td>In Progress</td>
                <td>1</td>
                <td>1</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
              <tr>
                <td>3</td>
                <td>Python Dev – Freelancer</td>
                <td>NN</td>
                <td>NN</td>
                <td>NN</td>
                <td>7+ Years</td>
                <td>In Progress</td>
                <td>1</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
                <td>0</td>
              </tr>
            </tbody>
          </table>
        );
      case "tab2":
        return (
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Position</th>
                <th>Name</th>
                <th>Mobile No</th>
                <th>Email</th>
                <th>Total Exp</th>
                <th>Relevant Exp</th>
                <th>Current CTC</th>
                <th>ECTC</th>
                <th>Notice Period</th>
                <th>Location</th>
                <th>Round</th>
                <th>Feedback</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Magento Developer – Gurgaon</td>
                <td>Swati Sharma</td>
                <td>9876543210</td>
                <td>swati@email.com</td>
                <td>4.5</td>
                <td>3.8</td>
                <td>₹9 LPA</td>
                <td>₹13 LPA</td>
                <td>Immediate</td>
                <td>Gurgaon</td>
                <td>Tech + HR</td>
                <td>Positive</td>
                <td>Shortlisted</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Data Modeler – Freelancer</td>
                <td>Rajat Verma</td>
                <td>9876543211</td>
                <td>rajat@email.com</td>
                <td>6.2</td>
                <td>6</td>
                <td>₹15 LPA</td>
                <td>₹18 LPA</td>
                <td>7 days</td>
                <td>Remote</td>
                <td>Screening</td>
                <td>OK</td>
                <td>On Hold</td>
              </tr>
            </tbody>
          </table>
        );
      case "tab3":
        return (
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Candidate</th>
                <th>Position</th>
                <th>Round</th>
                <th>Interviewer</th>
                <th>Date</th>
                <th>Feedback Summary</th>
                <th>Go Ahead (Y/N)</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Swati Sharma</td>
                <td>Magento Dev</td>
                <td>Tech</td>
                <td>Amit</td>
                <td>2 Aug</td>
                <td>Good technical hold, confident, relevant exp</td>
                <td>Yes</td>
                <td>Can negotiate on CTC</td>
              </tr>
              <tr>
                <td>2</td>
                <td>Rajat Verma</td>
                <td>Data Modeler</td>
                <td>Screening</td>
                <td>Shruti</td>
                <td>3 Aug</td>
                <td>Lacking real-time implementation clarity</td>
                <td>No</td>
                <td>Ask to reapply in 6 months</td>
              </tr>
            </tbody>
          </table>
        );
      case "tab4":
        return (
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Name</th>
                <th>Position</th>
                <th>Offered CTC</th>
                <th>Status</th>
                <th>Expected DOJ</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>Swati Sharma</td>
                <td>Magento Dev – Gurgaon</td>
                <td>₹13 LPA</td>
                <td>Offer Accepted</td>
                <td>5 Aug</td>
                <td>Awaiting final doc verification</td>
              </tr>
            </tbody>
          </table>
        );
      default:
        return null;
    }
  };

  return (
    <div className="container mt-4">
      <h3>Hiring Dashboard</h3>
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "tab1" ? "active" : ""}`}
            onClick={() => setActiveTab("tab1")}
          >
            Weekly Hiring Summary
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "tab2" ? "active" : ""}`}
            onClick={() => setActiveTab("tab2")}
          >
            Candidate Pipeline
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "tab3" ? "active" : ""}`}
            onClick={() => setActiveTab("tab3")}
          >
            Feedback Summary
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "tab4" ? "active" : ""}`}
            onClick={() => setActiveTab("tab4")}
          >
            Offer Tracker
          </button>
        </li>
      </ul>

      <div className="tab-content mt-3">{renderTable()}</div>
      <button className="btn btn-primary mb-3" onClick={exportAllTabsAsCSV}>
  Export All Tabs as CSV (ZIP)
</button>

    </div>
  );
};

export default WeeklyHiringsummary;
